/**
 * ★★★ WT lote 1 — "NÃO CARREGOU" É DIFERENTE DE "NÃO EXISTE".
 *
 * ⚠⚠ A medição achou **123** estados vazios e **nenhum** distinguia os dois
 * (`docs/wt-medicao.md` §2). ★ Uma lista vazia porque a consulta foi recusada parece, na
 * tela, igualzinha a uma lista vazia porque não há nada — e foi assim que o *"Fulano (fora
 * da função)"* do caso da Jéssica acusou o cadastro de uma pessoa.
 *
 * ★ O texto não culpa ninguém e dá o caminho: recarregar, e depois avisar o suporte.
 * ⚠ **Não mostra o erro técnico**: ele já está registrado, e código de erro na tela treina
 * a equipe a ignorar avisos.
 */
export default function AvisoCarga({ oQue, aoTentarDeNovo = null }) {
  return (
    <p className="aviso-carga" role="alert">
      Não foi possível carregar {oQue}. Recarregue a página. Se continuar, avise o suporte.
      {aoTentarDeNovo && (
        <>
          {' '}
          <button type="button" className="link" onClick={aoTentarDeNovo}>Tentar de novo</button>
        </>
      )}
    </p>
  );
}

/**
 * ★★★ WT lote 1b — A FAIXA DISCRETA DAS METAS.
 *
 * ⚠ As quatro telas que leem metas (Indicadores, Metas, Placar, Próximos Contatos) falhavam
 * só no console: a grade saía **sem cor** e o placar **não aparecia**, e a pessoa concluía
 * *"não tem meta configurada"* — que é outra coisa.
 *
 * ★★ Por que uma faixa própria e não o `AvisoCarga`: ela precisa **não empurrar a grade**
 * (`role="status"`, uma linha, acima do conteúdo) e precisa dizer **o que a falta de metas
 * causa na tela**. ⚠ Um aviso genérico aqui deixaria a pessoa olhando a grade cinza sem
 * ligar uma coisa à outra.
 */
export function AvisoMetas() {
  return (
    <p className="aviso-metas" role="status">
      Não foi possível carregar as metas — a grade aparece sem cores. Recarregue.
    </p>
  );
}

/**
 * ★★★ WU-2/P3 — "PODE ESTAR DESATUALIZADO" É A TERCEIRA COISA.
 *
 * ⚠⚠ A tela já sabia dizer *"não carregou"* (`AvisoCarga`, vermelho) e *"carregou e está
 * vazio"* (o estado vazio). ★★★ Faltava a que produziu o caso de 16/out: **carregou, está
 * cheio, e está VELHO** — a meta estava no servidor desde 14/10 e a tela mostrava o retrato
 * do cache, sem erro nenhum.
 *
 * ★ `role="status"` e não `alert`: a pessoa pode continuar trabalhando — o dado está ali,
 * só não foi confirmado com o servidor. ⚠ Vermelho aqui treinaria a equipe a ignorar
 * vermelho.
 *
 * ★★ A faixa **sai sozinha** quando o servidor responde (`aoDesatualizar(false)`): quem a
 * mostra é estado, não um aviso que fica pendurado até recarregar.
 *
 * ★★★ WU-2b (16/out/2026) — **UMA faixa só, sem assunto.** ⚠ No canário da WU-2, com a
 * internet desligada, apareceram **três** faixas azuis (configuração da clínica, equipe, meta
 * do dia) dizendo quase a mesma coisa. ★ A causa é uma só — a conexão —, então o aviso é um
 * só: quem decide se ele aparece é o `LeadsProvider`, que junta todos os assuntos.
 * ⚠ Texto aprovado pelo dono; não trocar sem passar por ele.
 */
export const TEXTO_DESATUALIZADO =
  'Sem conexão com o servidor no momento. Alguns dados podem estar desatualizados. '
  + 'O sistema confere sozinho quando a internet voltar.';

export function AvisoDesatualizado() {
  return (
    <p className="aviso-desatualizado" role="status">
      {TEXTO_DESATUALIZADO}
    </p>
  );
}
